import React, { Component, createRef } from "react";
import { Button, Row, Col } from "reactstrap";
import QRCode from "react-qr-code";

class DoorQrDownload extends Component {
    constructor(props) {
        super(props);
        this.wrapRef = createRef();

        this.state = {
            lastBuiltUrl: "",
        };
    }

    componentDidMount() {
        this.updateUrl();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedGroup !== this.props.selectedGroup) {
            this.updateUrl();
        }
        // if uData loads async later
        if (prevProps.uData !== this.props.uData && !this.state.lastBuiltUrl) {
            this.updateUrl();
        }
    }

    updateUrl = () => {
        const url = this.buildJoinUrl();
        this.setState({ lastBuiltUrl: url });
    };

    buildJoinUrl = () => {
        const origin = window.location.origin;
        const group = this.props.uData?.clinicGroups?.find(
            (c) => c._id === this.props.selectedGroup
        );

        if (!group) return `${origin}/`;
        return `${origin}/${group.alias}?checkIn=true`;
    };

    getSvgElement = () => {
        const wrap = this.wrapRef.current;
        if (!wrap) return null;
        return wrap.querySelector("svg");
    };

    openLink = () => {
        const url = this.state.lastBuiltUrl;
        if (!url) return;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    downloadPng = () => {
        const svg = this.getSvgElement();
        if (!svg) return;

        // const TITLE_TEXT = "SCAN TO CHECK IN".translate(this.props.lang);

        // clone svg to ensure width/height exist
        const svgClone = svg.cloneNode(true);
        if (!svgClone.getAttribute("width")) svgClone.setAttribute("width", "256");
        if (!svgClone.getAttribute("height")) svgClone.setAttribute("height", "256");

        const serializer = new XMLSerializer();
        const svgStr = serializer.serializeToString(svgClone);

        const svgBlob = new Blob([svgStr], { type: "image/svg+xml;charset=utf-8" });
        const svgUrl = URL.createObjectURL(svgBlob);

        const img = new Image();

        img.onload = () => {
            const scale = 4; // print quality
            const qrSize = img.width * scale;

            const padding = 40;
            const titleHeight = 60;

            const canvas = document.createElement("canvas");
            canvas.width = qrSize + padding * 2;
            canvas.height = qrSize + padding * 2 + titleHeight;

            const ctx = canvas.getContext("2d");
            if (!ctx) return;

            // white background
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // title text
            // ctx.fillStyle = "#000000";
            // ctx.font = "bold 36px Arial, Helvetica, sans-serif";
            // ctx.textAlign = "center";
            // ctx.textBaseline = "middle";
            // ctx.fillText(
            //     TITLE_TEXT,
            //     canvas.width / 2,
            //     titleHeight / 2 + 10
            // );

            // draw QR
            ctx.imageSmoothingEnabled = false;
            ctx.drawImage(
                img,
                padding,
                titleHeight + padding,
                qrSize,
                qrSize
            );

            const pngUrl = canvas.toDataURL("image/png");

            const link = document.createElement("a");
            link.href = pngUrl;
            link.download = "door-qr.png";
            link.click();

            URL.revokeObjectURL(svgUrl);
        };

        img.src = svgUrl;
    };


    render() {
        const url = this.state.lastBuiltUrl;

        return (
            <div style={{ display: "grid", gap: 16 }}>
                <Row>
                    <Col lg="12">
                        <div style={{ fontWeight: 600, marginBottom: 8 }}>
                            {"Scan to check in".translate(this.props.lang)}
                        </div>

                        <div style={{ display: 'flex', gap: 30 }}>
                            <div
                                ref={this.wrapRef}
                                onClick={this.openLink}
                                style={{
                                    background: "#fff",
                                    padding: 16,
                                    width: "fit-content",
                                    cursor: "pointer",
                                    border: "1px solid #e5e5e5",
                                    borderRadius: 6,
                                }}
                                title={url}
                            >
                                <QRCode value={url || ""} size={256} bgColor="#ffffff" fgColor="#000000" />
                            </div>
                            <div>
                                <ui >
                                    <div >{'How it works'.translate(this.props.lang)}</div>

                                    <ol>
                                        <li>{'You print the QR-code and set it up along with instructions in your waiting room'.translate(this.props.lang)}</li>
                                        <li>{'The patient scans the QR-code upon their arrival'.translate(this.props.lang)}</li>
                                        <li>{'The patient logs in and check in to their appointment'.translate(this.props.lang)}</li>
                                        <li>{"The clinician gets notified and the visit is marked as `checked in`".translate(this.props.lang)}</li>
                                    </ol>
                                </ui>
                            </div>
                        </div>

                        <div style={{ marginTop: 10, fontSize: 12, wordBreak: "break-all" }}>
                            <span style={{ opacity: 0.75 }}>{'Link'.translate(this.props.lang)}: </span>
                            <a href={url} target="_blank" rel="noopener noreferrer">
                                {url}
                            </a>
                        </div>
                    </Col>
                </Row>

                <Row style={{ gap: 8, marginLeft: 0 }}>
                    <Button color="primary" onClick={this.downloadPng} disabled={!url}>
                        {"Download PNG".translate(this.props.lang)}
                    </Button>
                </Row>
            </div>
        );
    }
}

export default DoorQrDownload;
